import { PropsWithChildren } from 'react';

export const IntakeDrawerContent = ({ children }: PropsWithChildren) => {
  return <div style={{ width: 420, padding: 24, marginBottom: 24 }}>{children}</div>;
};
